import { render, staticRenderFns } from "./DeleteAccount.vue?vue&type=template&id=a7312590&scoped=true"
import script from "./DeleteAccount.vue?vue&type=script&lang=js"
export * from "./DeleteAccount.vue?vue&type=script&lang=js"
import style0 from "./DeleteAccount.vue?vue&type=style&index=0&id=a7312590&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7312590",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7312590')) {
      api.createRecord('a7312590', component.options)
    } else {
      api.reload('a7312590', component.options)
    }
    module.hot.accept("./DeleteAccount.vue?vue&type=template&id=a7312590&scoped=true", function () {
      api.rerender('a7312590', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DeleteAccount.vue"
export default component.exports